// @ts-nocheck
import React, { useEffect, useRef, useState } from "react";
import { Dropdown } from 'react-bootstrap';
import { useHistory } from "react-router-dom";
const ListBoxItem = (props) => {
    const history = useHistory();
    const nameRef = useRef(null)
    const [isHazard, setIsHazard] = useState(!!props.data.isHazard);

    useEffect(() => {
        setIsHazard(!!props.data.isHazard);
    }, [props.data.isHazard]);

    const handleNameUpdate = () => {
        const newName = nameRef.current.textContent.trim();

        props.onHandleEditItem(props.data.id, newName, isHazard)

    };

    const handleHazardUpdate = (e) => {
        e.stopPropagation();
        const checked = e.target.checked;
        const newName = nameRef.current.textContent.trim();
        setIsHazard(checked);
        props.onHandleEditItem(props.data.id, newName, checked);
    };

    return (
        <>

            <div className={`list d-flex justify-content-between align-items-center p-3 border-bottom cursor-pointer ${(props.selectedId === props.data.id ? "active" : '')}`} onClick={() => props.onHandleSelect(props.data.id)}>

                <div className="content">
                    <p
                        className="content-editable list-name m-0"
                        ref={nameRef}
                        contentEditable="true"
                        onBlur={handleNameUpdate}
                        autoComplete="off"
                    >
                        {props.data.name}
                    </p>
                    {props.showHazard && (
                        <label className="d-flex align-items-center mt-2 mb-0" onClick={(e) => e.stopPropagation()}>
                            <input
                                type="checkbox"
                                className="me-2"
                                checked={isHazard}
                                onChange={handleHazardUpdate}
                            />
                            <span>Hazard</span>
                        </label>
                    )}
                    {/* <p className="list_text">Hello, last date for registering for the annual music event is closing in</p> */}
                </div>
                <div className="options">
                    {/* <Dropdown variant="p-0">
                        <Dropdown.Toggle variant="dropdown-toggle p-0 no-caret">
                            <i className="ti-more-alt"></i>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>

                            <Dropdown.Item> */}
                                <div onClick={() => props.onHandleDelete(props.data.id)}><i className="mdi mdi-delete me-2" style={{fontSize:20}}></i></div>
                            {/* </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown> */}
                </div>
            </div>



        </>
    )
}

export default ListBoxItem;
